const ACTION_STATUSES = {
  fix_redirect: ['REDIRECT'],
  recheck: ['BROKEN', 'REDIRECT', 'TIMEOUT', 'SERVER_ERROR', 'CHECK_ERROR'],
  delete: ['BROKEN', 'WRONG_DOMAIN', 'CHECK_ERROR', 'NO_DESTINATION'],
};

export function selectedAuditRows(rows, selection, view, action) {
  if (selection.view !== view) return [];
  return rows.filter(row => selection.ids.has(row.id) && (!action || ACTION_STATUSES[action]?.includes(row.health_status)));
}

// Use the existing single-Pin action sequentially, never a separate bulk API.
export async function processAuditSelection({ action, rows, confirm, isCurrent, isSelected, perform, onProgress }) {
  const snapshot = rows.filter(row => ACTION_STATUSES[action]?.includes(row.health_status));
  if (!snapshot.length || !isCurrent()) return;
  if (action === 'delete' && !await confirm('Delete the selected Pins permanently from Pinterest?')) return;
  if (!isCurrent()) return;
  const progress = { action, total: snapshot.length, done: 0, failed: 0, skipped: 0 };
  onProgress({ ...progress });
  for (const row of snapshot) {
    if (!isCurrent()) break;
    if (!isSelected(row.id)) progress.skipped++;
    else if (!await perform(row, action)) progress.failed++;
    progress.done++;
    if (isCurrent()) onProgress({ ...progress });
  }
}
